import React from "react";
import Add from "./add";
import {useDispatch, useSelector} from "react-redux";
import {onChangeVisibleDrawer} from "../../../../redux/actions/layout/interaction/action";
import DgModal from "../../../../custom/feedback/modal";

const ModalAddParent = ({databaseKey}) => {

    const dispatch = useDispatch()
    const {visibleDrawer} = useSelector(state => state.layoutInteractionReducer)

    return (
        <DgModal visible={visibleDrawer}
                  width={900}
                  onCancel={() => dispatch(onChangeVisibleDrawer(false))}
                  title={"Phiếu cân xe"}
                  bodyStyle={{
                      minHeight: 100,
                      maxHeight: 600,
                      overflowY: "scroll",
                      paddingRight: 0
                  }}
                  destroyOnClose={true}
                  okText={"Lưu phiếu"}
                  className="modalStyle"
        >
            <Add databaseKey={databaseKey}/>
        </DgModal>
    )
}

export default ModalAddParent
